<template>
  <input
    ref="input"
    :value="modelValue"
    :type="type"
    class="form-control"
    :placeholder="placeholder"
    :disabled="disabled"
    @input="handleInput"
    @focus="handleFocus"
  />
</template>

<script>
export default {
  name: 'TextInput',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleFocus(event) {
      // Auto-select all text for easy overwriting
      event.target.select();
    },
    handleInput(event) {
      this.$emit('update:modelValue', event.target.value);
    }
  },
  emits: ['update:modelValue']
}
</script>

<style scoped>
/* Inherits .form-control styles from global.css */
</style>
